import { createGetEndpoint } from '@sonar-software/sonar-http';
import { SonarObjectStakeholder } from '@types';

export type GetSonarObjectStakeholdersRequest = {
	sonarObjectId: number;
};

export type GetSonarObjectStakeholdersResponse = Array<SonarObjectStakeholder>;

export const getSonarObjectStakeholders = createGetEndpoint<
	GetSonarObjectStakeholdersRequest,
	GetSonarObjectStakeholdersResponse
>(({ sonarObjectId }) => `/api/v3/core/sonar-objects/${sonarObjectId}/stakeholders`);
